export const NonValueCell = ({ text }: { text: string }) => {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center relative">
      <div className="flex flex-col items-center gap-[10px] self-stretch">
        {/* Frame 2087329560 */}
        <div className="flex flex-col items-center gap-0.5">
          <span className="overflow-hidden text-primary body-1-normal-medium">
            {text}
          </span>
          <span className="text-neutral-500 label-2-medium">
            값이 있는 셀을 선택해주세요.
          </span>
        </div>
      </div>
    </div>
  );
};
